<template>
    <div class="row" v-if="isValid('CanViewAllowance')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">

            <div class="card">
                <div class="BorderBottom ml-2 mr-2 mt-3 mb-3">
                    <span class=" DayHeading">{{ $t('Allowance.Allowance') }}</span>
                </div>
                <div class="card-body">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('Allowance.SearchByName') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('Allowance.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a href="javascript:void(0)" class="btn btn-primary " style="margin-top:27px;" v-on:click="openmodel" v-if="isValid('CanAddAllowance')"><i class="fa fa-plus"></i> {{ $t('Allowance.AddNew') }} </a>
                            <router-link :to="'/ProductManagement'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger " style="margin-top:27px;">  <i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                            </router-link>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <table class="table table-striped table-hover table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <thead v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr>
                                        <th>#</th>
                                        <th class="text-center">
                                            {{ $t('Allowance.Code') }}
                                        </th>
                                        <th v-if="english=='true'">
                                            {{ $t('Allowance.NameEnglish')}}
                                        </th>
                                        <th v-if="isOtherLang()" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                            {{ $t('Allowance.NameArabic')}}
                                        </th>
                                        <th class="text-center">
                                            {{ $t('Allowance.AmountPercentage') }}
                                        </th>
                                        <th class="text-center">
                                            {{ $t('Allowance.Taxable') }}
                                        </th>
                                        <th>
                                            {{ $t('Allowance.Status') }}
                                        </th>


                                    </tr>
                                </thead>
                                <tbody v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr v-for="(allowance,index) in allowancelist" v-bind:key="allowance.id">
                                        <td v-if="currentPage === 1">
                                            {{index+1}}
                                        </td>
                                        <td v-else>
                                            {{((currentPage*10)-10) +(index+1)}}
                                        </td>

                                        <td class="text-center" v-if="isValid('CanEditAllowance')">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditAllowance(allowance.id)">{{allowance.code}}</a>
                                            </strong>
                                        </td>
                                        <td class="text-center" v-else>
                                            <strong>
                                                {{allowance.code}}
                                            </strong>
                                        </td>

                                        <td v-if="english=='true'">
                                            {{allowance.allowanceNameEn}}
                                        </td>
                                        <td v-if="isOtherLang()">
                                            {{allowance.allowanceNameAr}}
                                        </td>
                                        <td class="text-center">
                                            <span v-if="allowance.amountType==2">{{currency}} </span>  {{allowance.amount}} <span v-if="allowance.amountType==1">%</span>
                                        </td>
                                        <td class="text-center">
                                            {{allowance.taxPlan==1? $t('Allowance.Taxable'):$t('Allowance.NonTaxable')}}
                                        </td>
                                        <td>{{allowance.isActive==true?$t('Active'):$t('De-Active')}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="float-left">
                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                    </div>
                    <div class="float-right">
                        <div class="overflow-auto" v-on:click="GetAllowanceData()">
                            <b-pagination pills size="lg" v-model="currentPage"
                                          :total-rows="rowCount"
                                          :per-page="10"
                                          first-text="First"
                                          prev-text="Previous"
                                          next-text="Next"
                                          last-text="Last"></b-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <addAllowance :allowance="newAllowance"
                      :show="show"
                      v-if="show"
                      @close="IsSave"
                      :type="type" />

    </div>

    <div v-else> <acessdenied></acessdenied></div>
</template>


<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        data: function () {
            return {
                searchQuery: '',
                currency: '',
                show: false,
                allowancelist: [],
                newAllowance: {
                    id: '',
                    allowanceTypeId: '',
                    amountType: '',
                    taxPlan: '',
                    description: '',
                    amount:0,
                    code: '',
                    isActive: true
                },
                type: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                arabic: '',
                english: '',
            }
        },
        watch: {
            search: function (val) {
                this.GetAllowanceData(val, 1);
            }
        },
        methods: {
            IsSave: function () {
                
                this.show = false;

                this.GetAllowanceData(this.search, this.currentPage);
            },
            getPage: function () {
                this.GetAllowanceData(this.search, this.currentPage);
            },
            openmodel: function () {
                this.newAllowance = {
                    id: '00000000-0000-0000-0000-000000000000',
                    allowanceTypeId: '',
                    amountType: '',
                    taxPlan: '',
                    description: '',
                    amount: 0,
                    code: '',
                    isActive: true

                }
                this.show = !this.show;
                this.type = "Add";
            },
            GetAllowanceData: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('Payroll/AllowanceList?isDropdown=false' + '&pageNumber=' + this.currentPage + '&searchTerm=' + this.search, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.allowancelist = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });
            },
            EditAllowance: function (Id) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Payroll/AllowanceDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                            root.newAllowance.id = response.data.id;
                            root.newAllowance.allowanceTypeId = response.data.allowanceTypeId;
                            root.newAllowance.amountType = response.data.amountType;
                            root.newAllowance.taxPlan = response.data.taxPlan;
                            root.newAllowance.description = response.data.description;
                            root.newAllowance.code = response.data.code;
                            root.newAllowance.isActive = response.data.isActive;
                            root.newAllowance.amount = response.data.amount;
                            root.show = !root.show;
                            root.type = "Edit"
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },
        created: function () {
            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.currency = localStorage.getItem('currency');

            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.GetAllowanceData(this.search, 1);

        }
    }
</script>